import { HTMLAttributes } from "react";
import { FieldElement } from "./styles/field";

interface FieldProps extends HTMLAttributes<HTMLDivElement> {
  height: number;
}

export function Field({ height, ...props }: FieldProps) {
  return <FieldElement height={height} {...props} />;
}
